import type { RestorationPlan } from "../../types/dental";

interface VeneerToolboxProps {
  plan: RestorationPlan;
  onUpdatePlan: (planId: string, updates: Partial<RestorationPlan>) => void;
}

export function VeneerToolbox({ plan, onUpdatePlan }: VeneerToolboxProps) {
  return (
    <section className="procedure-toolbox-card card">
      <h3>Veneer Toolbox</h3>

      <div className="field-stack">
        <div className="field-row">
          <label>Material</label>
          <select
            value={plan.material || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { material: e.target.value })
            }
          >
            <option value="">Select material</option>
            <option value="Lithium Disilicate">Lithium Disilicate</option>
            <option value="Composite">Composite</option>
          </select>
        </div>

        <div className="field-row">
          <label>Shade</label>
          <input
            type="text"
            value={plan.shade || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { shade: e.target.value })
            }
          />
        </div>

        <div className="field-row">
          <label>Design Notes</label>
          <textarea
            value={plan.designNotes || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { designNotes: e.target.value })
            }
          />
        </div>
      </div>
    </section>
  );
}